import { type ReadonlyRequestCookies } from 'next/dist/server/web/spec-extension/adapters/request-cookies';

import { type Geo } from '@videoblocks/events-ts/lib/storyblocks/navigation/PageViewEvent';

import KafkaRestClient from '../kafka/KafkaRestClient';
import lookupUser from '../shared/lookupUser';
import { PageViewEventFactory } from './PageViewEventFactory';

async function publishEvent(
    currentUrl: URL,
    cookies: ReadonlyRequestCookies,
    headers: Headers,
    statusCode: number,
    referrer: URL | undefined,
    geo: Geo | null,
): Promise<void> {
    const visitorIdCookie = cookies.get('VID')?.value ?? null;
    const loginSessionToken = cookies.get('login_session')?.value;
    const searchIdCookie = cookies.get('SSLID')?.value ?? null;
    const searchPageIdCookie = cookies.get('SGUID')?.value ?? null;

    const event = await PageViewEventFactory.create({
        headers,
        currentUrl: currentUrl,
        visitorCookieId: visitorIdCookie,
        statusCode,
        searchPageIdCookie,
        searchIdCookie,
        referrer,
        geo,
        sessionToken: loginSessionToken,
    });

    await KafkaRestClient.produce(event);
}

export const PageViewService = { publishEvent };
